/**
 *
 * CardsGridWithChildren
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SSection, SCol, SContainer, SRow, STitle } from './styles';
import CardsGrid from 'components/CardsGrid';
import DotSVG from 'components/DotSVG';
import Heading2 from 'components/Heading/H2';
import { SpacedTitle } from 'components/Layout/styles';

const CardsGridWithChildren = ({
  data,
  isChildLeft = false,
  children,
  displayStarSvg,
  title,
  padding = true,
  inLine = false,
}) => {
  const colSizesIfChildren = children
    ? 'col-12 col-xl-auto'
    : 'col-lg-12 col-xl-auto';
  const firstColOrder = isChildLeft ? 'order-xl-0' : 'order-xl-5';
  const secondColOrder = isChildLeft ? 'order-xl-5' : 'order-xl-0';
  return (
    <SSection padding={padding}>
      <SContainer>
        {title && (
          <STitle>
            <SpacedTitle colorVariant="accentDark"> FEATURES </SpacedTitle>
            <Heading2 text={title} />
          </STitle>
        )}
        <SRow>
          {displayStarSvg && (
            <DotSVG $moveY="2px" right top width="40%" moveToRight />
          )}
          {children && (
            <SCol
              // sm="auto"
              sm="7"
              xl="4"
              className={`order-0 ${firstColOrder} pe-xl-5 mt-5 pt-5 mt-xl-0 pt-xl-0`}
            >
              {children && children}
            </SCol>
          )}
          <SCol className={`order-5 ${secondColOrder} ${colSizesIfChildren}`}>
            <CardsGrid data={data} inLine={inLine} />
          </SCol>
        </SRow>
      </SContainer>
    </SSection>
  );
};

CardsGridWithChildren.propTypes = {
  isChildLeft: PropTypes.bool,
  children: PropTypes.node,
  data: PropTypes.object,
  displayStarSvg: PropTypes.bool,
  title: PropTypes.string,
  padding: PropTypes.bool,
  inLine: PropTypes.bool,
};

export default CardsGridWithChildren;
